import React from "react";
import Context from "../../Context";
import { api, apiToken } from "../../api";
import { Link } from "react-router-dom";

export default class ConfirmEmail extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      error: false,
      errorMessage: "",
      pending: true,
    };
  }
  componentDidMount() {
    this.load();
  }
  load = async () => {
    this.setState({ pending: true });
    let clientToken = new apiToken();
    await clientToken.new();

    let fetchHeaders = new Headers({});
    fetchHeaders.append("Content-Type", "application/json");

    fetchHeaders.append(
      "Authorization",
      `Bearer ${clientToken.tk.access_token}`
    );
    let query = await api.fetch(
      "/verification/email/confirm",
      { code: this.props.code },
      fetchHeaders,
      "POST"
    );
    if (query) {
      if (query.result === true) {
        this.setState({ success: true, error: false });
      } else {
        this.setState({
          success: false,
          error: true,
          errorMessage: query.message,
        });
      }
    } else {
      clientToken.flush();
      this.setState({
        success: false,
        error: true,
        errorMessage:
          "Произошла неизвестная ошибка. Попробуйте повторить попытку позже",
      });
    }

    this.setState({ pending: false });
  };
  showPending() {
    return (
      <div className="d-flex align-items-center justify-content-center mh100">
        <span className="spinner spinner-track spinner-lg spinner-primary mr-15"></span>{" "}
        Пожалуйста подождите. Проверка E-Mail...
      </div>
    );
  }
  showFail() {
    return (
      <div className="d-flex align-items-center justify-content-center mh100">
        <div className="w-75 card card-custom wave  wave-danger mb-8 mb-lg-0">
          <div className="card-body">
            <div className="d-flex align-items-center p-5">
              <div className="mr-6">
                <span className="svg-icon svg-icon-danger svg-icon-4x">
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <path
                        d="M12.9835977,18 C12.7263047,14.0909841 9.47412135,11 5.5,11 C4.98630124,11 4.48466491,11.0516454 4,11.1500272 L4,7 C4,5.8954305 4.8954305,5 6,5 L20,5 C21.1045695,5 22,5.8954305 22,7 L22,16 C22,17.1045695 21.1045695,18 20,18 L12.9835977,18 Z M19.1444251,6.83964668 L13,10.1481833 L6.85557487,6.83964668 C6.4908718,6.6432681 6.03602525,6.77972206 5.83964668,7.14442513 C5.6432681,7.5091282 5.77972206,7.96397475 6.14442513,8.16035332 L12.6444251,11.6603533 C12.8664074,11.7798822 13.1335926,11.7798822 13.3555749,11.6603533 L19.8555749,8.16035332 C20.2202779,7.96397475 20.3567319,7.5091282 20.1603533,7.14442513 C19.9639747,6.77972206 19.5091282,6.6432681 19.1444251,6.83964668 Z"
                        fill="#000000"
                      />
                      <path
                        d="M6.5,14 C7.05228475,14 7.5,14.4477153 7.5,15 L7.5,17 C7.5,17.5522847 7.05228475,18 6.5,18 C5.94771525,18 5.5,17.5522847 5.5,17 L5.5,15 C5.5,14.4477153 5.94771525,14 6.5,14 Z M6.5,21 C5.94771525,21 5.5,20.5522847 5.5,20 C5.5,19.4477153 5.94771525,19 6.5,19 C7.05228475,19 7.5,19.4477153 7.5,20 C7.5,20.5522847 7.05228475,21 6.5,21 Z"
                        fill="#000000"
                        opacity="0.3"
                      />
                    </g>
                  </svg>
                </span>
              </div>
              <div className="d-flex flex-column">
                <div className="text-dark   font-weight-bold font-size-h4 mb-3">
                  E-Mail не подтвержден
                </div>
                <div className="text-dark-75">{this.state.errorMessage}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  showSuccess() {
    return (
      <div className="d-flex align-items-center justify-content-center mh100">
        <div className="w-75 card card-custom wave  wave-success mb-8 mb-lg-0">
          <div className="card-body">
            <div className="d-flex align-items-center p-5">
              <div className="mr-6">
                <span className="svg-icon svg-icon-success svg-icon-4x">
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24" />
                      <path
                        d="M4.875,20.75 C4.63541667,20.75 4.39583333,20.6541667 4.20416667,20.4625 L2.2875,18.5458333 C1.90416667,18.1625 1.90416667,17.5875 2.2875,17.2041667 C2.67083333,16.8208333 3.29375,16.8208333 3.62916667,17.2041667 L4.875,18.45 L8.0375,15.2875 C8.42083333,14.9041667 8.99583333,14.9041667 9.37916667,15.2875 C9.7625,15.6708333 9.7625,16.2458333 9.37916667,16.6291667 L5.54583333,20.4625 C5.35416667,20.6541667 5.11458333,20.75 4.875,20.75 Z"
                        fill="#000000"
                        fillRule="nonzero"
                        opacity="0.3"
                      />
                      <path
                        d="M12.9835977,18 C12.7263047,14.0909841 9.47412135,11 5.5,11 C4.98630124,11 4.48466491,11.0516454 4,11.1500272 L4,7 C4,5.8954305 4.8954305,5 6,5 L20,5 C21.1045695,5 22,5.8954305 22,7 L22,16 C22,17.1045695 21.1045695,18 20,18 L12.9835977,18 Z M19.1444251,6.83964668 L13,10.1481833 L6.85557487,6.83964668 C6.4908718,6.6432681 6.03602525,6.77972206 5.83964668,7.14442513 C5.6432681,7.5091282 5.77972206,7.96397475 6.14442513,8.16035332 L12.6444251,11.6603533 C12.8664074,11.7798822 13.1335926,11.7798822 13.3555749,11.6603533 L19.8555749,8.16035332 C20.2202779,7.96397475 20.3567319,7.5091282 20.1603533,7.14442513 C19.9639747,6.77972206 19.5091282,6.6432681 19.1444251,6.83964668 Z"
                        fill="#000000"
                      />
                    </g>
                  </svg>
                </span>
              </div>
              <div className="d-flex flex-column">
                <div className="text-dark   font-weight-bold font-size-h4 mb-3">
                  E-Mail подтвержден
                </div>
                <div className="text-dark-75">
                  E-mail адрес успешно подтвержден
                </div>
                <div>
                  <Link to="/" className="text-success">
                    На главную
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <>
        {this.state.error ? this.showFail() : null}
        {this.state.success ? this.showSuccess() : null}
        {this.state.pending ? this.showPending() : null}
      </>
    );
  }
}
